module.exports = __webpack_public_path__ + "img/login-lights-background.33bd6f65.svg";